export default __webpack_public_path__ + "static/media/opay.1085497c.webp";